/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable import/no-dynamic-require */
import { ReactComponent as CloseIcon } from 'assets/icons/close_square.svg';
import { IDataPages, IDataProducts } from 'common/contracts';
import { GeneralInfoTextContainer, GeneralInfoTitle } from 'common/styles/GeneralInfo.styles';
import { ActiveStateIndicator, MenuContainer, MenuItem } from 'common/styles/Menu.style';
import {
  HeaderImageWrapper,
  LoadingWrap,
  ModalBodyContent,
  ModalBodyContentLeft,
  ModalBodyContentRight,
  ModalCloseBtn,
  ModalContainer,
  ModalImageWrap,
  PrimaryModalLeftContainer,
  PrimaryModalRightContainer
} from 'common/styles/Modal.styles';
import Breadcrumb, { IBreadcrumb } from 'components/BreadCrumb/Breadcrumb';
import LogoIcon from 'components/LogoIcon/LogoIcon';
import PointComp from 'components/PointComp/PointComp';
import { pageData } from 'data/pages';
import { productsData } from 'data/products';
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import { toCamelCase } from 'utils/callbacks';
import CommonUtils from 'utils/common';
import MarkerUtils from 'utils/marker';

const Room = ({ mRoute }: { mRoute: string }) => {
  const [active, setActive] = useState<string>('');
  const [imgUrl, setImgUrl] = useState<string>('');
  const history = useHistory();
  const { params } = useRouteMatch<{ facility: string; room: string; product: string }>();
  const breadcrumbs: IBreadcrumb[] = [
    {
      title: 'Home',
      link: '/',
      active: false
    },
    {
      title: toCamelCase(params.facility),
      link: `/${params.facility}`,
      active: false,
      handler: () => {
        history.push(CommonUtils.path(history.location.pathname));
      }
    },
    {
      title: params.room ? toCamelCase(params.room) : mRoute,
      link: '',
      active: true
    }
  ];

  const onClickHandler = (id: string) => {
    // const productSlug = toSnakeCase(id);

    MarkerUtils.handleSecondaryPointClick(id);
    history.push(`${history.location.pathname}/${id}`);
  };

  const onMouseEnterHandler = (id: string) => {
    setActive(id);
  };

  const onMouseLeaveHandler = () => {
    setActive('');
  };

  const [productList, setProductList] = useState<IDataProducts[]>([]);
  const [currentPageData, setCurrentPageData] = useState<IDataPages>();
  const [currentFacility, setCurrentFacility] = useState<IDataPages>();

  useEffect(() => {
    // filter rooms of facility

    const currentPage = pageData.find(item => item.route === mRoute || item.route === params.room);

    // filter facility

    const currentFacilityPage = pageData.find(item => item.route === params.facility);

    // filter products of room

    const p = productsData.filter(
      item => (item.roomRoute === params.room || item.roomRoute === mRoute) && item.facilityRoute === params.facility
    );

    // console.log(productList);
    setProductList(p);
    setCurrentFacility(currentFacilityPage);
    setCurrentPageData(currentPage);
    // es-lint-disable-next-line react-hooks/exhaustive-deps
  }, [mRoute, params.facility, params.room]);

  return (
    <>
      {currentPageData ? (
        <ModalContainer>
          <LogoIcon />
          <ModalImageWrap onClick={() => history.push(CommonUtils.path(history.location.pathname))}>
            <img
              src={
                // eslint-disable-next-line global-require
                require(`../../assets/images/rooms/${currentFacility?.route}/${currentFacility?.backgroundImage}`)
                  .default
              }
              alt={currentFacility?.title}
            />
          </ModalImageWrap>
          <ModalBodyContent open animation="zoom-in">
            <ModalCloseBtn
              onClick={() => {
                history.push(CommonUtils.path(history.location.pathname));
              }}
            >
              <CloseIcon />
            </ModalCloseBtn>
            {/* <HStack> */}
            <ModalBodyContentLeft>
              <PrimaryModalLeftContainer>
                {/* Bread Crumb -----------*/}
                <Breadcrumb breadcrumbs={breadcrumbs} />
                {/* Room image ---------------- */}

                <HeaderImageWrapper>
                  <img
                    src={
                      // eslint-disable-next-line global-require
                      require(`../../assets/images/rooms/${currentPageData.parentRoute}/${currentPageData.backgroundImage}`)
                        .default
                    }
                    alt={currentPageData.title}
                    style={{ width: '100%' }}
                  />
                  {/* Green points ------------- */}
                  {productList.map((item: IDataProducts, idx: number) => (
                    <PointComp
                      key={idx}
                      position={item.pos}
                      handleClick={() => onClickHandler(item.id)}
                      isExpanded={active === item.id}
                      handleMouseEnter={() => onMouseEnterHandler(item.id)}
                      handleMouseLeave={() => onMouseLeaveHandler()}
                    >
                      {item.title}
                    </PointComp>
                  ))}
                </HeaderImageWrapper>
                {/* Room content ----------------------- */}
                <GeneralInfoTextContainer>
                  <GeneralInfoTitle>{currentPageData.title}</GeneralInfoTitle>
                  {currentPageData.content.map((desc: string, i: number) => (
                    <p key={i}>{desc}</p>
                  ))}
                </GeneralInfoTextContainer>
              </PrimaryModalLeftContainer>
            </ModalBodyContentLeft>
            <ModalBodyContentRight>
              <MenuContainer>
                {productList.map((item: IDataProducts, idx: number) => (
                  <MenuItem key={idx} onMouseEnter={() => setActive(item.id)} onMouseLeave={() => setActive('')}>
                    <Link to={`/${params.facility}/${params.room}/${item.id}`}>
                      {item.title} <ActiveStateIndicator show={active === item.id} />
                    </Link>
                  </MenuItem>
                ))}
              </MenuContainer>
            </ModalBodyContentRight>
            {/* </HStack> */}
          </ModalBodyContent>
        </ModalContainer>
      ) : (
        <LoadingWrap>Loading</LoadingWrap>
      )}
    </>
  );
};

export default Room;
